import { Observable } from 'rxjs';
import {
    CancelationInterface,
    CancelationResponseInterface,
} from '../models/cancelation.model';

export abstract class CancelationRepository {
    abstract cancelReservation(
        params: CancelationInterface,
    ): Observable<CancelationResponseInterface>;
}
